import React, { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getClasses, getClassesToken } from "../../redux/services/classesSlice";
import Loader from "../../common/Loader";

const QuestionPanel = () => {
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [totalData, setTotalData] = useState(0);
  const [subjectData, setSubjectData] = useState([]);
  const limit = 12;
  const getAllClasses = useCallback(async () => {
    setLoading(true);
    try {
      const response = await dispatch(getClasses({ page: page, limit: limit }));
      if (response?.payload?.status === 200) {
        const fetchedData = response.payload?.data?.classes_data || [];
        setSubjectData((prevData) => [...prevData, ...fetchedData]);
        const totalRecords = response.payload?.data?.state?.page_limit || 0;
        setTotalData(totalRecords);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  }, [dispatch, page, limit]);

  useEffect(() => {
    getAllClasses();
  }, [getAllClasses]);
  const handleLoadMore = () => {
    setPage((prevPage) => prevPage + 1);
  };
  const getClassesData = async (classesId) => {
    try {
      const response = await dispatch(getClassesToken(classesId));
      if (response?.payload?.status === 200) {
        window.open(`${process.env.REACT_APP_QUESTION_PANEL_URL}?token=${response.payload?.data}&classesId=${classesId}`);
      }
    } catch (error) {}
  };
  return (
    <div>
      <section className="h-full">
        <div className="sm:p-4">
          {subjectData?.length > 0 ? (
            <div className="grid grid-cols-1 gap-2 sm:grid-cols-2 md:gap-6 lg:grid-cols-3 lg:gap-2 xl:grid-cols-4 xl:gap-3 2xl:grid-cols-4 2xl:gap-6">
              {subjectData?.map((value, index) => {
                return (
                  <div
                    className="bg-card shadow-theme border rounded-xl p-4 space-y-3 cursor-pointer"
                    key={index}
                    onClick={() => getClassesData(value?._id)}
                  >
                    <div className="flex flex-row items-center justify-between">
                      <p className="font-semibold text-lg uppercase text-primary w-[calc(100%-100px)]">
                        {value.name}
                      </p>
                      <div className="h-[60px] w-[60px]">
                        <img
                          src={value?.image}
                          className="block shadow-sm rounded-xl h-full w-full"
                          alt={value.name}
                        />
                      </div>
                    </div>
                    <p className="font-medium text-muted-foreground text-lg capitalize">
                      {value?.ownerName || "-"}
                    </p>
                  </div>
                );
              })}
            </div>
          ) : (
            <Loader />
          )}
          {page < totalData && (
            <div className="text-center my-6">
              <button
                className="bg-primary text-white py-2 px-4 rounded-xl hover:bg-accent font-medium text-lg"
                onClick={handleLoadMore}
                disabled={loading}
              >
                {loading ? "Loading..." : "Load More..."}
              </button>
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default QuestionPanel;
